import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import type { OverlayModerationStatus } from "../types";

interface OverlayStatusBadgeProps {
  status: OverlayModerationStatus;
}

const statusClass: Record<OverlayModerationStatus, string> = {
  pending: "bg-amber-500/20 text-amber-400 border-amber-500/30",
  approved: "bg-green-500/20 text-green-400 border-green-500/30",
  rejected: "bg-red-500/20 text-red-400 border-red-500/30",
};

const OverlayStatusBadge = ({ status }: OverlayStatusBadgeProps) => {
  const { t } = useTranslation("common");
  const labels: Record<OverlayModerationStatus, string> = {
    pending: t("OVERLAYS.statusPending", "Pending"),
    approved: t("OVERLAYS.statusApproved", "Approved"),
    rejected: t("OVERLAYS.statusRejected", "Rejected"),
  };
  return <Badge className={statusClass[status]}>{labels[status]}</Badge>;
};

export default OverlayStatusBadge;
